import getBlockId from './getBlockId';
export function shortenBlockId(blockId) {
  return blockId.split('-')[0];
}
export default function getBlockShortId(block) {
  return shortenBlockId(getBlockId(block));
}